export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'celebrity-scandals',
    name: '明星塌房',
    description: '明星出轨、吸毒、偷税漏税等塌房现场第一时间爆料',
    icon: 'ri-fire-line',
    articleCount: 128,
  },
  {
    slug: 'daily-gossip',
    name: '每日黑料',
    description: '每日精选娱乐圈最热黑料大瓜，吃瓜不迷路',
    icon: 'ri-newspaper-line',
    articleCount: 256,
  },
  {
    slug: 'exclusive-news',
    name: '独家猛料',
    description: '全网首发独家爆料，深度追踪事件真相',
    icon: 'ri-vip-crown-line',
    articleCount: 86,
  },
  {
    slug: 'film-tv',
    name: '影视圈',
    description: '剧组内幕、选角黑幕、片酬曝光、导演风波',
    icon: 'ri-movie-line',
    articleCount: 64,
  },
  {
    slug: 'influencer-drama',
    name: '网红瓜',
    description: '网红撕逼、带货翻车、 fake人设崩塌',
    icon: 'ri-live-line',
    articleCount: 92,
  },
  {
    slug: 'variety-show',
    name: '综艺爆料',
    description: '综艺节目幕后真相、嘉宾冲突、剧本门事件',
    icon: 'ri-tv-line',
    articleCount: 45,
  },
];